import React, { useEffect,Suspense } from 'react'  
////import Categories from '../components/our-collection/Categories'
const Categories = React.lazy(() => import('../components/our-collection/Categories'));
 
export default function FilterCategory({ sendBodyClass }) {
     

    // const SubCategoriesData = 
    // { 
      
    //   Heading: '',  
    //   SubCategoriesList: [
    //       {
    //           contentType: "subCategory",
    //           name: "Giveaways Bundle",
    //           createDate: "2024-11-14T15:21:30.213Z",
    //           updateDate: "2024-11-14T15:21:30.213Z",
    //           route: {
    //               path: "/our-collection/giveaways/giveaways-bundle/",
    //               startItem: {
    //                   id: "93bf9f93-c762-4df5-96da-bb0e0b963d85",
    //                   path: "home"
    //               }
    //           },
    //           id: "dd1975e1-c750-40e3-9645-9fdff2a1555f",
    //           properties: {}
    //       },
    //       {
    //           contentType: "subCategory",
    //           name: "Occasional Giveaways",
    //           createDate: "2024-11-14T15:21:30.213Z",
    //           updateDate: "2024-11-14T15:21:30.213Z",
    //           route: {
    //               path: "/our-collection/giveaways/occasional-giveaways/",
    //               startItem: {
    //                   id: "93bf9f93-c762-4df5-96da-bb0e0b963d85",
    //                   path: "home"
    //               }
    //           },
    //           id: "dd1975e1-c750-40e3-9645-9fdff2a2514f",
    //           properties: {}
    //       },
    //       {
    //           contentType: "subCategory",
    //           name: "PR and Promotional Gift boxes",
    //           createDate: "2024-11-14T15:22:43.79Z",
    //           updateDate: "2024-11-14T15:22:43.79Z",
    //           route: {
    //               path: "/our-collection/giveaways/pr-and-promotional-gift-boxes/",
    //               startItem: {
    //                   id: "93bf9f93-c762-4df5-96da-bb0e0b963d85",
    //                   path: "home"
    //               }
    //           },
    //           id: "29a6df03-ea32-43b8-a4d9-50f90783fd1a",
    //           properties: {}
    //       },
    //       {
    //           contentType: "subCategory",
    //           name: "Bagpack",
    //           createDate: "2024-11-14T15:21:30.213Z",
    //           updateDate: "2024-11-14T15:21:30.213Z",
    //           route: {
    //               path: "/our-collection/bags/bagpack/",
    //               startItem: {
    //                   id: "93bf9f93-c762-4df5-96da-bb0e0b963d65",
    //                   path: "home"
    //               }
    //           },
    //           id: "dd1975e1-c750-40e3-9645-9fdff2a4a11f",
    //           properties: {}
    //       },
    //       {
    //           contentType: "subCategory",
    //           name: "Canvas Bag",
    //           createDate: "2024-11-14T15:21:30.213Z",
    //           updateDate: "2024-11-14T15:21:30.213Z",
    //           route: {
    //               path: "/our-collection/bags/canvas-bag/",
    //               startItem: {
    //                   id: "93bf9f93-c762-4df5-96da-bb0e0b963d65",
    //                   path: "home"
    //               }
    //           },
    //           id: "dd1975e1-c750-40e3-9645-9fdff2a4a12f",
    //           properties: {}
    //       },
    //       {
    //           contentType: "subCategory",
    //           name: "Diary With Pen Holder",
    //           createDate: "2024-11-14T15:22:43.79Z",
    //           updateDate: "2024-11-14T15:22:43.79Z",
    //           route: {
    //               path: "/our-collection/diary/diary-with-pen-holder/",
    //               startItem: {
    //                   id: "93bf9f93-c762-4df5-96da-bb0e0b963d75",
    //                   path: "home"
    //               }
    //           },
    //           id: "29a6df03-ea32-43b8-a4d9-50f90783f21a",
    //           properties: {}
    //       },
    //       {
    //           contentType: "subCategory",
    //           name: "Diary With Strap",
    //           createDate: "2024-11-14T15:22:43.79Z",
    //           updateDate: "2024-11-14T15:22:43.79Z",
    //           route: {
    //               path: "/our-collection/diary/diary-with-strap/",
    //               startItem: {
    //                   id: "93bf9f93-c762-4df5-96da-bb0e0b963d75",
    //                   path: "home"
    //               }
    //           },
    //           id: "29a6df03-ea32-43b8-a4d9-50f907832d1a",
    //           properties: {}
    //       },
    //       {
    //           contentType: "subCategory",
    //           name: "Ceramic Mug",
    //           createDate: "2024-11-14T15:22:43.79Z",
    //           updateDate: "2024-11-14T15:22:43.79Z",
    //           route: {
    //               path: "/our-collection/mugs/ceramic-mug/",
    //               startItem: {
    //                   id: "93bf9f93-c762-4df5-96da-bb0e0b963d55",
    //                   path: "home"
    //               }
    //           },
    //           id: "29a6df03-ea32-43b8-a4d9-50f907832s2a",
    //           properties: {}
    //       },
    //       {
    //           contentType: "subCategory",
    //           name: "Coffee Mug",
    //           createDate: "2024-11-14T15:22:43.79Z",
    //           updateDate: "2024-11-14T15:22:43.79Z",
    //           route: {
    //               path: "/our-collection/mugs/coffee-mug/",
    //               startItem: {
    //                   id: "93bf9f93-c762-4df5-96da-bb0e0b963d55",
    //                   path: "home"
    //               }
    //           },
    //           id: "29a6df03-ea32-43b8-a4d9-50f907832e1j",
    //           properties: {}
    //       }
    //   ],
      
    //   Description: '',  

    // };

    useEffect(() => {
      sendBodyClass(false); 
    }, []);
  return (
    <>
    <Suspense fallback={<div>Loading...</div>}>
      <Categories />
      </Suspense>
    </>
  )
}
